<template>
    <div v-if="visible" class="form-overlay" @click.self="closeList">
        <div class="form-container">
            <button class="close-btn" @click="closeList">X</button>
            <h2>業務員銷售統計</h2>
            <form @submit.prevent="submitForm">
                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group">
                            <label for="sales_id">業務員</label>
                            <select id="sales_id" v-model="formData.sales_id">
                                <option v-for="sales in salesList" :key="sales.id" :value="sales.id">
                                    {{ sales.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="start_date">查詢</label>
                            <select id="search_field" v-model="formData.search_fields.date_field">
                                <option value="order_date">訂貨日期</option>
                                <option value="deliver_date">到貨日期</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="start_date">從</label>
                            <input type="date" id="start_date" v-model="formData.search_fields.start_date">
                        </div>
                        <div class="form-group">
                            <label for="end_date">到</label>
                            <input type="date" id="end_date" v-model="formData.search_fields.end_date">
                        </div>
                        <div class="form-group">
                            <label></label>
                            <button type="submit" class="submit-btn" :disabled="isSubmitting">查詢</button>
                        </div>
                    </div>
                    <div class="form-row">
                        <button type="button" class="month-btn" @click="setMonth(1)" :id="1">一月</button>
                        <button type="button" class="month-btn" @click="setMonth(2)" :id="2">二月</button>
                        <button type="button" class="month-btn" @click="setMonth(3)" :id="3">三月</button>
                        <button type="button" class="month-btn" @click="setMonth(4)" :id="4">四月</button>
                        <button type="button" class="month-btn" @click="setMonth(5)" :id="5">五月</button>
                        <button type="button" class="month-btn" @click="setMonth(6)" :id="6">六月</button>
                        <button type="button" class="month-btn" @click="setMonth(7)" :id="7">七月</button>
                        <button type="button" class="month-btn" @click="setMonth(8)" :id="8">八月</button>
                        <button type="button" class="month-btn" @click="setMonth(9)" :id="9">九月</button>
                        <button type="button" class="month-btn" @click="setMonth(10)" :id="10">十月</button>
                        <button type="button" class="month-btn" @click="setMonth(11)" :id="11">十一月</button>
                        <button type="button" class="month-btn" @click="setMonth(12)" :id="12">十二月</button>
                        <div class="form-group checkbox-group">
                            <input type="checkbox" id="only_delivered" v-model="formData.search_fields.only_delivered">
                            <label for="only_delivered">只看已交付</label>
                        </div>
                    </div>
                </div>
            </form>
            <h3>查詢結果</h3>
            <div class="order-list-container">
                <table class="order-list">
                    <thead>
                        <tr class="total-row">
                            <td class="total-value">{{salesList.find(s => s.id == this.searchResult.sales_id)?.name}}
                            </td>
                            <td colspan="2" class="total-value">{{ this.searchResult.search_fields ?
                                (this.searchResult.search_fields.date_field == 'deliver_date' ? "到貨日期" : "訂貨日期") : "" }}
                            </td>
                            <td class="total-value">總計 {{ searchResult.orders.length }}件</td>
                            <td colspan="2" class="total-value">已交付 {{searchResult.orders.reduce((sum, order) => sum +
                                (order.delivered ? 1 : 0), 0)}}件</td>
                            <td class="total-value">總金額 {{formatCurrency(searchResult.orders.reduce((sum, order) => sum
                                + order.sales_amount, 0))}}</td>
                            <td class="total-value">總分潤 {{formatCurrency(searchResult.orders.reduce((sum, order) => sum
                                + order.share_profit, 0))}}</td>
                        </tr>
                        <tr>
                            <th>已交付</th>
                            <th>訂單編號</th>
                            <th>顧客姓名</th>
                            <th>訂貨日期</th>
                            <th>到貨日期</th>
                            <th>假日分潤</th>
                            <th>銷售金額</th>
                            <th>分潤</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="order in searchResult.orders" :key="order.id">
                            <tr @click="toggleOrderItems(order.id)"
                                :class="{ 'expanded': expandedOrderId === order.id }" class="order-row">
                                <td>
                                    <input type="checkbox" :checked="order.delivered"
                                        @click.stop="toggleDeliveredStatus(order, $event)"
                                        :disabled="userAuthority > 1">
                                </td>
                                <td>{{ order.id }}</td>
                                <td>{{ order.name }}</td>
                                <td class="date-column">{{ order.order_date }}</td>
                                <td class="date-column">{{ order.deliver_date }}</td>
                                <td>{{ order.share_day ? "是" : "" }}</td>
                                <td>{{ formatCurrency(order.sales_amount) }}</td>
                                <td>{{ formatCurrency(order.share_profit) }}</td>
                            </tr>
                            <tr v-if="expandedOrderId === order.id && expandedOrder" :key="expandedOrderId + '-details'" class="order-row">
                                <td colspan="9">
                                    <div class="order-list">
                                        <h3>平攤成本細項</h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>總金額</th>
                                                    <th>發票費</th>
                                                    <th>信用卡手續費</th>
                                                    <th>回收費</th>
                                                    <th>分攤成本</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ formatCurrency(expandedOrder.sales_amount) }}</td>
                                                    <td>{{ formatCurrency(expandedOrder.invoice_fee) }}</td>
                                                    <td>{{ formatCurrency(expandedOrder.credit_card_fee) }}{{ getCreditCardPaymentText(expandedOrder) }}</td>
                                                    <td>{{ formatCurrency(expandedOrder.disposal_fee) }}</td>
                                                    <td>{{ formatCurrency(expandedOrder.share_cost) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="order-list">
                                        <h3>訂單細項</h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>尺寸</th>
                                                    <th>品項</th>
                                                    <th>銷售金額</th>
                                                    <th>商品成本</th>
                                                    <th>平攤成本</th>
                                                    <th>銷售毛利</th>
                                                    <th>單項分潤</th>
                                                    <th>數量</th>
                                                    <th>總分潤</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in expandedOrder.order_items" :key="item.id">
                                                    <td>{{ item.size + (item.customized ? '(特殊)' : '') }}</td>
                                                    <td>{{ item.name + (item.color ? " (" + item.color + ")" : '') }}
                                                    </td>
                                                    <td>{{ formatCurrency(item.sales_amount) }}</td>
                                                    <td>{{ formatCurrency(item.cost) }}</td>
                                                    <td>{{ formatCurrency(item.share_cost) }} ({{ order.sales_amount > 0 ? (item.sales_amount * item.quantity / order.sales_amount * 100).toFixed(2) : 0 }}%)</td>
                                                    <td>{{ formatCurrency(item.profit) }}</td>
                                                    <td>{{ formatCurrency(item.share_profit) }}</td>
                                                    <td>{{ item.quantity }}</td>
                                                    <td>{{ formatCurrency(item.total_share_profit) }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="8" class="total-label">分潤總計</td>
                                                    <td class="total-value">{{formatCurrency(expandedOrder.order_items.reduce((sum,
                                                        item) => sum + item.total_share_profit, 0))}}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div class="order-detail-actions">
                                        <button @click="editOrder()" class="edit-btn">編輯訂單</button>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <OrderForm :visible="showOrderForm" :order-id="expandedOrderId" @close="closeOrderForm" />
    </div>
</template>

<script>
import OrderForm from './OrderForm.vue';

export default {
    components: {
        OrderForm
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        userAuthority: {
            type: Number,
            default: 2,
        },
    },
    emits: ['close', 'refresh-order-list'],
    data() {
        return {
            salesList: [],
            formData: {
                sales_id: '',
                search_fields: {
                    date_field: 'deliver_date',
                    start_date: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().split('T')[0],
                    end_date: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().split('T')[0],
                    only_delivered: false
                }
            },
            searchResult: {
                sales_id: null,
                search_flelds: {
                },
                orders: []
            },
            orderItems: [],
            expandedOrderId: null,
            expandedOrder: null,
            isSubmitting: false,
            showOrderForm: false
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.fetchSalesList();
            }
        },
        'formData.only_delivered': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.submitForm();
            }
        }
    },
    methods: {
        closeList() {
            this.$emit('close');
        },
        async fetchSalesList() {
            try {
                const response = await fetch('/api/sales');
                if (!response.ok) throw new Error('Failed to fetch sales list');
                this.salesList = await response.json();
                this.formData.sales_id = this.salesList[0].id;
            } catch (error) {
                console.error('Error fetching sales list:', error);
            }
        },
        async submitForm() {
            if (!this.formData.sales_id) {
                alert('請選擇業務員');
                return;
            }

            this.isSubmitting = true;
            try {
                const response = await fetch('/api/sales_order_stat', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.formData)
                })

                if (!response.ok) throw new Error('Failed to fetch order list');
                this.searchResult = await response.json();
            } catch (error) {
                console.error('Error fetching order list:', error);
            }
            this.isSubmitting = false;
        },
        setMonth(month) {
            console.log(month);
            this.formData.search_fields.start_date = new Date(Date.UTC(new Date().getFullYear(), month - 1, 1)).toISOString().split('T')[0];
            this.formData.search_fields.end_date = new Date(Date.UTC(new Date().getFullYear(), month, 0)).toISOString().split('T')[0];
            this.submitForm();
        },
        async fetchOrderStat(order_id) {
            try {
                const response = await fetch(`/api/order_stat/${order_id}`);
                if (!response.ok) throw new Error('Failed to fetch order stat');
                this.expandedOrder = await response.json();
            } catch (error) {
                console.error('Error fetching order stat:', error);
            }
        }, 
        toggleOrderItems(orderId) {
            if (this.expandedOrderId === orderId) {
                this.expandedOrderId = null;
            } else {
                this.expandedOrderId = orderId;
                this.fetchOrderStat(orderId);
            }
        },
        formatCurrency(val) {
            const v = val || 0;
            return new Intl.NumberFormat('zh-TW', {
                style: 'currency',
                currency: 'TWD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(v);
        },
        getCreditCardPaymentText(order) {
            if (order.payments) {
                const creditCardPayments = order.payments.filter(p => p.method_id === 2);
                if (creditCardPayments.length > 0) {
                    return creditCardPayments.map(p => ` (${this.formatCurrency(p.amount)} ${p.pay_date})`).join('');
                }
            }
            return '';
        },
        async toggleDeliveredStatus(order, event) {
            // If the user is trying to mark as delivered and deliver_date is not set
            if (!order.delivered && !order.deliver_date) {
                alert('請先填寫交貨日期');
                if (event) {
                    event.preventDefault(); // Prevent the checkbox from changing its state
                }
                return; // Prevent updating status
            }

            try {
                const newStatus = !order.delivered;
                const response = await fetch(`/api/orders/${order.id}/delivered`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ delivered: newStatus })
                });
                if (!response.ok) throw new Error('Failed to update delivery status');
                const data = await response.json();
                order.delivered = data.delivered;

            } catch (error) {
                if (event) {
                    event.preventDefault();
                }
                console.error('Error updating delivery status:', error);
                alert('更新交貨狀態失敗');
            }
        },
        editOrder() {
            this.showOrderForm = true;
        },
        closeOrderForm() {
            this.showOrderForm = false;
            if (this.expandedOrderId) {
                this.fetchOrderStat(this.expandedOrderId);
            }
            this.submitForm();
        }
    }
}
</script>

<style scoped>
.form-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    z-index: 1000;
    overflow-y: auto;
}

.form-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.close-btn:hover {
    background: #e2e8f0;
}

h2 {
    color: #1a202c;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
}

.form-section {
    margin-bottom: 1.5rem;
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    align-items: center;
}

.form-group {
    display: flex;
    flex-direction: column;
    min-width: 150px;
}

.checkbox-group {
    flex-direction: row;
    gap: 0.5rem;
    min-width: unset;
}

.checkbox-group input[type="checkbox"] {
    width: auto;
}

.checkbox-group label {
    margin-bottom: 0px;
    text-align: center;
}

label {
    margin-bottom: 0.4rem;
    font-weight: 500;
    color: #4a5568;
    font-size: 1rem;
}

input[type="date"],
select {
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    background-color: white;
}

input[type="date"]:focus,
select:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.month-btn {
    background-color: #e3f2fd;
    color: #2c3e50;
    border: none;
    margin: 2px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-btn {
    background-color: #2c3e50;
    color: white;
    border: none;
    padding: 12px 12px;
    margin: 2px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-btn:hover {
    background-color: #1a252f;
}

.submit-btn:disabled {
    background-color: #cbd5e0;
    cursor: not-allowed;
}

.order-list-container {
    margin-top: 1.5rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.order-list {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
    margin-bottom: 1.5rem;
}

.order-list th,
.order-list td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
}

.order-list th {
    background-color: #f0f0f0;
    color: #2c3e50;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 1rem;
    letter-spacing: 0.05em;
    position: sticky;
    top: 0;
    z-index: 10;
}

.order-row {
    transition: background-color 0.2s;
}

.date-column {
  min-width: 80px;
  max-width: 80px;
}

.order-row.expanded {
    background-color: #e3f2fd;
}

.details-row {
    background-color: #fafafa;
}

.details-row td {
    padding: 0;
    border-bottom: 1px solid #e2e8f0;
}

.details-container {
    padding: 1.25rem;
}

.section {
    margin-bottom: 1.5rem;
}

.section h3 {
    margin: 0 0 1rem 0;
    color: #2d3748;
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e2e8f0;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0.75rem;
    font-size: 1rem;
}

th,
td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
}

th {
    background-color: #f8f9fa;
    color: #2c3e50;
    font-weight: 600;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

tr:nth-child(even) {
    background-color: #f8fafc;
}

.total-row {
    color: #2c3e50;
}

.total-row td {
    padding-bottom: 1.5rem;
}

.total-label,
td.total-label {
    text-align: right;
    padding-right: 1rem;
    font-weight: 600;
}

.total-value,
td.total-value {
    text-align: left;
    padding-left: 1rem;
    font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .form-row {
        flex-direction: column;
        gap: 0.75rem;
    }

    .form-group {
        width: 100%;
    }

    .submit-btn {
        width: 100%;
        margin-top: 0.25rem;
    }

    .form-container {
        width: 95%;
        padding: 1rem;
    }

    .order-list th,
    .order-list td {
        padding: 0.5rem;
    }
}

.order-detail-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
    padding-right: 1rem;
}

.edit-btn {
    background-color: #4CAF50; /* Matching OrdersList.vue */
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 1rem; /* Matching OrdersList.vue (default font size) */
    cursor: pointer;
    margin-right: 8px; /* Matching OrdersList.vue */
    font-weight: 500; /* Matching OrdersList.vue */
    transition: background-color 0.3s;
}

.edit-btn:hover {
    background-color: #45a049; /* Matching OrdersList.vue */
}
</style>
